"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WALLETCONNECT = exports.MYALGOWALLET = void 0;

var _myalgowallet = _interopRequireDefault(require("./logos/myalgowallet.png"));

var _walletconnect = _interopRequireDefault(require("./logos/walletconnect.png"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MYALGOWALLET = {
  id: "myalgowallet",
  name: "MyAlgoWallet",
  logo: _myalgowallet.default,
  type: "qrcode"
};
exports.MYALGOWALLET = MYALGOWALLET;
var WALLETCONNECT = {
  id: "walletconnect",
  name: "WalletConnect",
  logo: _walletconnect.default,
  type: "qrcode",
  package: {
    required: [["infuraId", "rpc"]]
  }
};
exports.WALLETCONNECT = WALLETCONNECT;